// @flow
import * as React from 'react';

import { selectCartUUID } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';
import { Alert, Button } from '@gandi/ui';

import { useAppSelector } from 'src/hooks';

import type { CreateOrTransfer } from '../../../types';

type OwnProps = {
  createTlds: Array<string>,
  process: CreateOrTransfer,
  onClickEdit: () => void,
};

type Props = { ...OwnProps };

export default function WarningBox({
  createTlds,
  process,
  onClickEdit,
}: Props): React.MixedElement {
  const { __ } = useTranslator();
  const cartId = useAppSelector(selectCartUUID);

  const message =
    process === 'create'
      ? __(
          '<p>The contact information below will be used for the domain names' +
            ' in your shopping cart if possible.' +
            ' For %(tlds)s domains,' +
            ' you have provided alternative or complementary information.<p>' +
            '<br/><p>If you make any changes to the contacts below,' +
            ' they will be applied to all of the domains in the shopping cart.' +
            ' and so you will need to once again provide any special information' +
            ' that is required for %(tlds)s domains.</p>',
          {
            withHTML: true,
            tlds: createTlds.map(tld => `.${tld.toUpperCase()}`).join(', '),
          },
        )
      : __(
          '<p>The contact information below will be used for the domain names' +
            ' your shopping cart if possible.' +
            ' For some of the domains, you have provided alternative' +
            ' or complementary information.</p>' +
            '<br/><p>If you make any changes to the contacts below,' +
            ' they will be applied to all of the domains in the shopping cart.</p>',
          { withHTML: true },
        );

  return (
    <Alert
      intent="warning"
      title={__('Domain contacts used for this order')}
      buttons={[
        <Button type="button" small grouped onClick={onClickEdit}>
          {__('Edit anyway')}
        </Button>,
        <Button small grouped to={`/cart/${cartId}/overview`}>
          {__('Back to cart')}
        </Button>,
      ]}
      marginBottom="base"
      message={message}
    />
  );
}
